import { SocketTopics } from "@shared/types";
import { ExchangeToSymbolHandler } from "@shared/services/socket/handlers/ExchangeToSymbolHandler";
import { InitialDataHandler } from "@shared/services/socket/handlers/InitialDataHandler";
import { TradeIdsHandler } from "@shared/services/socket/handlers/TradeIdsHandler";
import { TradeExtraDetailsHandler } from "@shared/services/socket/handlers/TradeExtraDetailsHandler";
import { BasicHandler } from "@shared/services/socket/handlers/BasicHandler";

export const topicReducer = {
  [SocketTopics.PRICES]: new ExchangeToSymbolHandler(),
  [SocketTopics.GRAPHS_DATA]: new ExchangeToSymbolHandler(),
  [SocketTopics.AGG_BOTS]: new InitialDataHandler(),
  [SocketTopics.AGG_TRADES]: new InitialDataHandler(),
  [SocketTopics.PNL]: new TradeIdsHandler(),
  [SocketTopics.GLOBAL_PNL]: new BasicHandler(),
  [SocketTopics.NOTIFICATIONS]: new BasicHandler(),
  [SocketTopics.TRADE_EXTRA_DETAILS]: new TradeExtraDetailsHandler(),
};

export const GLOBAL_PNL_MIN_TRADES = 30;
